import PropTypes from "prop-types";
import React from "react";

function FormLabel({ as, children, required = false, ...props }) {
  const requiredIndicator = required ? (
    <span className="form-required">*</span>
  ) : null;

  const Component = as || "span";

  return (
    <Component {...props}>
      {requiredIndicator}
      {children}
    </Component>
  );
}

FormLabel.propTypes = {
  as: PropTypes.elementType,
  children: PropTypes.node.isRequired,
  required: PropTypes.bool,
};

export { FormLabel };
